import { ToWords } from 'to-words';
const toWords = new ToWords({ localeCode: 'en-US' });
import { formatToCurrency } from '@/lib/helpers';

export const generateLoanApprovalSummary = ({
  company,
  loan,
  preparedBy,
  accreditedBranch
}) => {
  const borrowerInfo = {
    fullName: `${loan.loanDistributions[0].person.firstName} ${
      loan.loanDistributions[0].person.middleName || ''
    } ${loan.loanDistributions[0].person.lastName}`,
    accountNumber: `${loan.account.mainAccountNumber}`,
    address: loan.loanDistributions[0].person.livingAddress,
    contact: loan.loanDistributions[0].person.contact[0].number
  };
  loan.loanAmountInWords = toWords
    .convert(loan?.loanAmount || 0, { currency: true, doNotAddOnly: true })
    .toUpperCase();
  loan.loanAmountInCurrency = formatToCurrency(loan.loanAmount);
  loan.paymentInCurrency = formatToCurrency(loan.frequencyPayment);

  const config = {
    info: {
      title: 'Insurance Summary', // name of the document being printed
      modDate: new Date(), // date the document was last modified
      creationDate: new Date(), // date the document was created
      keywords: 'insurance summary, statement of insurance, loan, finance', // keywords associated with the document
      author: 'Sodality Co-operative Credit Union Limited', // company name
      subject: 'Insurance Summary', // name of the document being printed
      creator: 'John Doe', // name of the logged in user
      producer: 'Sodality Co-operative Credit Union Limited' // company name
    },

    defaultStyle: {
      font: 'Lora',
      color: '#0f172a',
      fontSize: 11,
      lineHeight: 1.3
    },

    content: [
      {
        text: [
          { text: `${company.name}\n`, bold: true },
          `${accreditedBranch?.branchStreet || ''}\n`,
          `${accreditedBranch?.branchCity || ''}\n`,
          `${accreditedBranch?.branchProvince || ''} ${
            accreditedBranch.branchCountry || ''
          }\n`
        ],
        alignment: 'left'
      },
      { text: '\n\n' },
      {
        text: [
          { text: `${borrowerInfo.fullName}\n`, bold: true },
          `${borrowerInfo.address.street}\n`,
          `${borrowerInfo.address.city}\n`,
          `${borrowerInfo.address.province}, ${borrowerInfo.address.country}\n`,
          `${borrowerInfo.contact}\n`
        ],
        alignment: 'left'
      },
      { text: '\n\n' },
      {
        columns: [
          { text: 'Total Loan Amount:', alignment: 'left' },
          { text: `${loan.loanAmountInCurrency}`, alignment: 'right' }
        ]
      },
      {
        columns: [
          { text: 'Interest Rate (Annual):', alignment: 'left' },
          { text: `${loan.interest}%`, alignment: 'right' }
        ]
      },
      {
        columns: [
          { text: 'Tenure:', alignment: 'left' },
          { text: `${loan.tenure} Month(s)`, alignment: 'right' }
        ]
      },
      {
        columns: [
          { text: 'Monthly Payment:', alignment: 'left' },
          { text: `${loan.paymentInCurrency}`, alignment: 'right' }
        ]
      },
      {
        columns: [
          { text: 'Loan Product:', alignment: 'left' },
          { text: `${loan.loanProduct}`, alignment: 'right' }
        ]
      },
      { text: '\n\n' },
      {
        text: 'ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ',
        margin: [0, 0, 0, 10],
        decoration: 'underline'
      },
      {
        columns: [
          { text: 'Signature', alignment: 'left' },
          { text: 'Date Signed', alignment: 'right' }
        ]
      },
      { text: '\n\n' },
      {
        text: `Prepared By: ${preparedBy}`,
        alignment: 'left',
        margin: [0, 20, 0, 0]
      }
    ]
  };

  return config;
};
